import React from 'react';
import Event1Img from '../../Data/Assets/images/Event1Image.jpeg';
import Event11 from '../../Data/Assets/images/Event11.jpeg';
import Event12 from '../../Data/Assets/images/Event11.jpeg';
import Event13 from '../../Data/Assets/images/Event11.jpeg';
import './event1.css';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
function EventOne() {
  return (
    <div>
      <Navbar />
      <div id="event">
        <div id="title">
          IYNS at Second Joint IAEA-ICTP Workshop on Open-Source Nuclear Codes for Reactor Analysis,
          Trieste, Italy
        </div>
        <div id="image-gallery">
          <div id="big-image">
            <img src={Event1Img} alt={'event_main'} />
          </div>
          <div id="image-row">
            <div id="img-row-container">
              <img
                className="small_img"
                alt={'event_1_img'}
                src={Event11}
                style={{ marginRight: '1.25rem' }}
              />
              <img
                className="small_img"
                alt={'event_1_img'}
                src={Event12}
                style={{ marginRight: '1.25rem' }}
              />
              <img className="small_img" alt={'event_1_img'} src={Event13} />
            </div>
          </div>
        </div>
        <div id="page-content">
          <p>
            India’s first micro nuclear reactor, SUK-M, which is being designed by IYNS, was proudly
            presented by IYNS Vice-President Dr. Samyak Munot at the prestigious Second Joint
            IAEA-ICTP Workshop on Open-Source Nuclear Codes for Reactor Analysis, held in Trieste,
            Italy, from 22–26 September 2025.
          </p>
          <p>
            SUK-M is a 10 MWe molten salt micro reactor that employs thorium fuel and is being
            designed to deliver clean, reliable, and continuous power to around 50,000 Indian
            households for 10-15 years. The workshop has been instrumental in advancing the SUK-M
            project by providing crucial training and validation using open-source nuclear codes.
            Since the IAEA's open-source nuclear codes are approved by most global regulatory
            bodies, these tools enhance the design's precision and safety, empowering the IYNS team
            with cutting-edge computational capabilities.
          </p>
          <p>
            By integrating open-source simulation technologies, SUK-M is set to redefine not only
            India's energy landscape but also demonstrate the power of collaboration and innovation
            led by the country's youth.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EventOne;
